// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function PaypalLogoBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M27.909 11.385a7.476 7.476 0 0 0-2.438-2.034A7.5 7.5 0 0 0 18 2.5h-7.5a2.5 2.5 0 0 0-2.425 1.894l-4.5 18A2.5 2.5 0 0 0 6 25.5h2.799l-.224.894A2.5 2.5 0 0 0 11 29.5h3.938a2.5 2.5 0 0 0 2.425-1.894L18.39 23.5H22a7.5 7.5 0 0 0 5.911-12.115h-.002ZM10.89 5.5H18a4.471 4.471 0 0 1 3.546 1.731c.302.385.54.816.704 1.277-.082 0-.164-.008-.25-.008h-7a2.5 2.5 0 0 0-2.425 1.894L9.549 22.5H6.64l4.25-17Zm11.345 6.006A4.49 4.49 0 0 1 18 14.5h-3.359l.75-3H22c.078 0 .157 0 .236.006Zm4.125 5.585A4.492 4.492 0 0 1 22 20.5h-4a2.5 2.5 0 0 0-2.425 1.894L14.549 26.5H11.64l2.25-9H18a7.485 7.485 0 0 0 7.012-4.844 4.514 4.514 0 0 1 1.353 4.435h-.004Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
